import {
  BookOpen,
  Coins,
  Gift,
  FlaskConical,
  KeyRound,
  Megaphone,
  SlidersHorizontal,
  UserPlus,
  type LucideIcon,
} from 'lucide-react'
import type { AdminAccess } from './adminAccess'

export interface AdminToolDefinition {
  id: keyof AdminAccess
  href: string
  titleKey: string
  descriptionKey: string
  icon: LucideIcon
}

export const ADMIN_TOOLS: readonly AdminToolDefinition[] = [
  {
    id: 'builtinSkills',
    href: '/admin/skills',
    titleKey: 'adminSkills.title',
    descriptionKey: 'adminSkills.description',
    icon: BookOpen,
  },
  {
    id: 'topup',
    href: '/admin/topup',
    titleKey: 'adminHub.topupTitle',
    descriptionKey: 'adminHub.topupDescription',
    icon: Coins,
  },
  {
    id: 'freeTrials',
    href: '/admin/free-trials',
    titleKey: 'adminFreeTrials.title',
    descriptionKey: 'adminFreeTrials.description',
    icon: Gift,
  },
  {
    id: 'flags',
    href: '/admin/flags',
    titleKey: 'adminHub.flagsTitle',
    descriptionKey: 'adminHub.flagsDescription',
    icon: SlidersHorizontal,
  },
  {
    id: 'banners',
    href: '/admin/banners',
    titleKey: 'adminHub.bannersTitle',
    descriptionKey: 'adminHub.bannersDescription',
    icon: Megaphone,
  },
  {
    id: 'internalModels',
    href: '/admin/internal-models',
    titleKey: 'adminHub.internalModelsTitle',
    descriptionKey: 'adminHub.internalModelsDescription',
    icon: FlaskConical,
  },
  {
    id: 'onboarding',
    href: '/admin/onboarding',
    titleKey: 'adminHub.onboardingTitle',
    descriptionKey: 'adminHub.onboardingDescription',
    icon: UserPlus,
  },
  {
    id: 'apiKeys',
    href: '/admin/api',
    titleKey: 'adminApiKeys.title',
    descriptionKey: 'adminApiKeys.description',
    icon: KeyRound,
  },
]
